import type { FC } from 'react';

import type { ListPagePickerProps } from '@/shared/ui/async-selector';

import { ListPage } from './ListPage';
import { ListPagePickerModal } from './ListPagePickerModal';
import type { ListPageConfig } from './model/types';

export interface ListPageHandle {
  /** Celá agenda ListPage — vykresluje se jako obsah okna. */
  Page: FC;
  /** Výběrový (picker) režim v modálním okně — pro ⋯ akci selectoru (`listPicker: { listPage }`). */
  Picker: FC<ListPagePickerProps>;
}

/**
 * Šablonová factory ListPage (vzor `defineEntityAsyncSelector`): modul deklaruje sloupce,
 * filtry a chování; engine v `shared/ui/list-page` dodá kompletní chování seznamu. Vrací jak
 * plnou agendu (`Page`), tak výběrový režim (`Picker`) — tatáž šablona v modálním okně.
 */
export function defineListPage<TItem, TStats = unknown>(
  config: ListPageConfig<TItem, TStats>
): ListPageHandle {
  function Page() {
    return <ListPage config={config} />;
  }
  Page.displayName = `ListPage(${config.key})`;

  function Picker(props: ListPagePickerProps) {
    return <ListPagePickerModal config={config} {...props} />;
  }
  Picker.displayName = `ListPagePicker(${config.key})`;

  return { Page, Picker };
}
